import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getIvaLista = async () => {
    const res = await getData('/tipoiva');
    return res
}


export const getIvaById = async (id) => {
    const res = await getData(`/tipoiva/${id}`)
    return res
}

export const postIva= async (body) => {
    const res = await postData('/tipoiva', body)
    return res
}

export const patchIva = async (id, body) => {
    const res = await patchData(`/tipoiva/${id}`, body)
    return res
}

export const deleteIva = async (id) => {
    const res = await deleteData(`/tipoiva/${id}`)
    return res
}